import { createSlice } from "@reduxjs/toolkit";
import { SliceAction } from "store/store";

const queryParamsLS = JSON.parse(window.localStorage.getItem("adminCustomersProxyPage") || "{}");
const queryParamsURL = Object.fromEntries(new URLSearchParams(window.location.search));

const isActivePage = window.location.pathname.includes("customers") && (queryParamsURL?.tab === "proxy")

const initialState: {
    activePaginationPage: number,
    activePaginationLimit: number,
} = Object.assign(
    (isActivePage && Object.keys(queryParamsURL).some(item => ["page", "limit"].includes(item)))
        ? {
            activePaginationPage: Number(queryParamsURL?.page || "1"),
            activePaginationLimit: Number(queryParamsURL?.limit || "50"),
        }
        : {
            activePaginationPage: Number(queryParamsLS?.page || "1"),
            activePaginationLimit: Number(queryParamsLS?.limit || "50"),
        }
);

window.localStorage.setItem("adminCustomersProxyPage", JSON.stringify({
    page: initialState.activePaginationPage,
    limit: initialState.activePaginationLimit,
}))

const customerProxySlice = createSlice({
    initialState,
    name: "customerProxyAdminPage",
    reducers: {
        setActivePaginationPage(state, action: SliceAction<(typeof initialState)["activePaginationPage"]>) {
            window.localStorage.setItem("adminCustomersProxyPage", JSON.stringify({
                page: action.payload,
                limit: state.activePaginationLimit,
            }))
            state.activePaginationPage = action.payload;
        },
        setActivePaginationLimit(state, action: SliceAction<(typeof initialState)["activePaginationLimit"]>) {
            window.localStorage.setItem("adminCustomersProxyPage", JSON.stringify({
                page: state.activePaginationPage,
                limit: action.payload,
            }))
            state.activePaginationLimit = action.payload;
        },
    },
});

const { reducer, actions } = customerProxySlice;

export default reducer;

export const {
    setActivePaginationLimit,
    setActivePaginationPage
} = actions;
